import { useState } from 'react';
import type { Video } from '@/types';

interface PlayerPanelProps {
  video: Video;
  onDemoNotice: (message: string) => void;
}

export default function PlayerPanel({ video, onDemoNotice }: PlayerPanelProps) {
  const [active, setActive] = useState(1);
  const isSeries = video.episodeCount > 1;
  const episodes = Array.from({ length: video.episodeCount }, (_, i) => i + 1);

  const startPlay = () => {
    onDemoNotice(
      isSeries
        ? `正在载入第 ${active} 集… 当前为演示模式，暂未提供在线播放源。`
        : '正在载入影片… 当前为演示模式，暂未提供在线播放源。',
    );
  };

  return (
    <div className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="flex items-center gap-2 text-lg font-semibold text-foreground-50">
          <i className="ri-play-list-2-line text-primary-500" />
          在线观看
        </h2>
        <span className="rounded-full bg-secondary-500/20 px-3 py-1 text-xs text-secondary-300">
          演示模式 · 暂无播放源
        </span>
      </div>

      <button
        type="button"
        onClick={startPlay}
        className="group relative flex aspect-video w-full items-center justify-center overflow-hidden rounded-lg border border-background-200 bg-background-200"
      >
        <img
          src={video.backdrop}
          alt={`${video.title} 播放预览`}
          title={`${video.title} 播放预览`}
          className="absolute inset-0 h-full w-full object-cover object-top opacity-60 transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-background-50/50" />
        <span className="relative flex h-16 w-16 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-transform group-hover:scale-110">
          <i className="ri-play-fill text-3xl" />
        </span>
        <span className="absolute bottom-4 left-4 text-sm font-medium text-foreground-100">
          {isSeries ? `第 ${active} 集` : '正片'}
        </span>
      </button>

      {isSeries && (
        <div className="mt-4">
          <p className="mb-3 text-sm text-foreground-400">
            选集（共 {video.episodeCount} 集）
          </p>
          <div className="grid max-h-40 grid-cols-5 gap-2 overflow-y-auto pr-1 sm:grid-cols-8 md:grid-cols-10">
            {episodes.map((ep) => (
              <button
                key={ep}
                type="button"
                onClick={() => {
                  setActive(ep);
                  onDemoNotice(`已切换到第 ${ep} 集（演示模式，暂未提供播放源）。`);
                }}
                className={`flex h-9 items-center justify-center rounded-md text-sm transition-colors ${
                  ep === active
                    ? 'bg-primary-500 font-semibold text-background-50'
                    : 'bg-background-200 text-foreground-300 hover:text-foreground-50'
                }`}
              >
                {ep}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}